import Barba from 'barba.js'
import TweenLite from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

export default Barba.BaseView.extend({
    namespace: 'withIntro',
    onEnter() {
        if( document.querySelector('.loader') ) {
            Barba.Dispatcher.on('pageLoading', () => {
                Barba.Pjax.Manager.getAnimationManager().get('intro').play()
            } )
        }
    },
    onEnterCompleted() {
        if( ! document.querySelector('.loader') || ! this.played ) {
            Barba.Pjax.Manager.getAnimationManager().get('intro').play()
        }
        document.querySelector('.scroll-indicator').addEventListener('click', el => TweenLite.to( window, 1, { scrollTo: window.innerHeight } ))
    },
    onLeave() {
    },
    onLeaveCompleted() {
    }
})